import { GameInputsMediator } from '@game-libs/inputs-mediator';
import { useRef, useState } from 'react';
import './sliders.scss';

export type SliderProps = {
  label: string;
  initialValue: number;
  onValueChange: (value: number) => void;
  isFirst?: boolean;
  enabled?: boolean;
};

export const Slider = ({ label, initialValue, onValueChange, isFirst, enabled = true }: SliderProps) => {
  const { inputValues } = GameInputsMediator();
  const [value, setValue] = useState(initialValue);
  let intervalRef = useRef(0);
  const inputRef = useRef<HTMLInputElement>(null);

  const subscribeToInputs = () => {
    intervalRef.current = setInterval(() => {
      if (!inputRef.current?.value) return;

      const increment = inputValues.move_right - inputValues.move_left;

      if (increment) {
        inputRef.current?.stepUp(increment);
        inputRef.current?.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 50) as unknown as number;
  };

  const unsubscribeToInputs = () => {
    clearInterval(intervalRef.current);
  };

  return (
    <div className={`slider-container${enabled ? '' : ' disabled'}`}>
      <label htmlFor={label + '_slider'}>{label}</label>
      <input
        autoFocus={isFirst}
        ref={inputRef}
        type="range"
        id={label + '_slider'}
        disabled={!enabled}
        min="0"
        max="100"
        value={value}
        onChange={(e) => {
          setValue(+e.target.value);
          onValueChange(+e.target.value);
          e.preventDefault();
        }}
        onFocus={subscribeToInputs}
        onBlur={unsubscribeToInputs}
      />
      <div>{value}</div>
    </div>
  );
};
